import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import imagebackup from "../images/grebenBcg.jpg"

const getData = graphql`
  query {
    site {
      siteMetadata {
        siteTitle: title
        siteDesc: description
        author
        siteUrl
        twitterUsername
      }
    }
  }
`

// const imagebackup =
//   "/static/544aaa383e06681a4b67c0eb1ee1e827/8688f/grebenBcg.jpg"

const SEO = ({ title, description, image }) => {
  const { site } = useStaticQuery(getData)

  const { siteDesc, siteTitle, siteUrl, twitterUsername } = site.siteMetadata

  return (
    <Helmet htmlAttributes={{ lang: "en" }} title={`${title} | ${siteTitle}`}>
      <meta
        name="google-site-verification"
        content="9gumCdgcgwRD6mIntcI_KLyw98Lij7BEs7VLq5CcnkE"
      />
      <meta name="description" content={description || siteDesc} />
      <meta name="image" content={imagebackup} />
      {/* facebook cards */}
      <meta property="og:url" content={siteUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDesc} />
      <meta property="og:image" content={`${siteUrl}${imagebackup}`} />
      <meta property="og:image:width" content="400" />
      <meta property="og:image:height" content="300" />
      {/* twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterUsername} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDesc} />
      <meta name="twitter:image" content={`${siteUrl}${imagebackup}`} />
    </Helmet>
  )
}

export default SEO
